import PropTypes from 'prop-types';
import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Notary} from '../classes/Notary';
import {Notification} from '../classes/Notification';
import locale from '../locale/Localization';
import {addChangeApplication} from '../script/application-service';
import {getPersonById, updateProfle} from '../script/person-service';
import {addNotifications, addUser} from '../store/appActions';
import NotaryApiManagement from './NotaryApiManagement';
import NotaryContracts from './NotaryContracts';
import NotaryForm from './NotaryForm';

const mapStateToProps = (state) => {
  return {user: state.user};
};

/**
 * Map the properties.x
 *
 * @param {*} dispatch
 * @return {Function} - The add user function.
 */
function mapDispatchToProps(dispatch) {
  return {
    addNotifications: (notification) =>
      dispatch(addNotifications(notification)),
    addUser: (user) => dispatch(addUser(user))
  };
}

/**
 * Component class of UserProfile.
 */
class ConnectedUserProfile extends Component {
  /**
   * Creates a UserProfile
   *
   * @param {Object} props - the property data
   */
  constructor(props) {
    super(props);

    // const notary = this.getNotary(props.user);
    this.state = {
      userData: null,
      userId: props.user.id
    };
  }

  componentDidMount = () => {
    getPersonById(this.props.user.id).then((response) => {
      this.setState({userData: this.getNotary(response)});
    });
  };

  /**
   * Convert user data to notary data.
   *
   * @param {Object} user - The user data.
   * @return {Object} - The notary data.
   */
  getNotary = (user) => {
    const organization = user.organisation || {};
    const businessContactInfo = organization.contactInformation || {};

    return new Notary(
      user.gender,
      user.firstNames,
      user.officialName,
      user.birthDate,
      null,
      organization.uid,
      organization.name,
      businessContactInfo.street,
      businessContactInfo.houseNumber,
      businessContactInfo.addition,
      businessContactInfo.postOffice,
      businessContactInfo.swissZip,
      businessContactInfo.town,
      businessContactInfo.careOf,
      businessContactInfo.mail,
      businessContactInfo.telephone,
      businessContactInfo.fax,
      null,
      null,
      null,
      user.functions,
      businessContactInfo.exportEmail,
      user.signatureDeclarationDocument,
      user.registrationDocument,
      user.terminationDocument,
      businessContactInfo.invoiceCompany,
      businessContactInfo.invoiceStreet,
      businessContactInfo.invoiceHouseNumber,
      businessContactInfo.invoiceSwissZip,
      businessContactInfo.invoiceTown,
      user.contactInformation ? user.contactInformation.mobileNumber : null
    );
  };

  /**
   * Convert user profile update data to person update data.
   *
   * @param {Object} profileUpdateData - The user profile update data.
   * @return {Object} - The person update data.
   */
  getPersonUpdateData = (profileUpdateData: Object) => {
    const personUpdateData = {
      organisation: {
        contactInformation: {
          exportEmail: profileUpdateData.exportEmail,
          fax: profileUpdateData.faxNumber,
          telephone: profileUpdateData.phoneNumber,
          invoiceCompany: profileUpdateData.invoiceCompany,
          invoiceStreet: profileUpdateData.invoiceStreet,
          invoiceHouseNumber: profileUpdateData.invoiceStreetNumber,
          invoiceSwissZip: profileUpdateData.invoicePostcode,
          invoiceTown: profileUpdateData.invoiceLocation,
          mail: profileUpdateData.email
        }
      },
      contactInformation: {mobileNumber: profileUpdateData.mobileNumber}
    };
    return personUpdateData;
  };

  /**
   * Handles the save of the user profile edit button and updates the user detail information.
   *
   * @param {Object} personData - Person data from submit action.
   */
  handleProfileSubmit = (personData: Object) => {
    const profile = {
      exportEmail: personData.exportEmail,
      faxNumber: personData.faxNumber,
      phoneNumber: personData.phoneNumber,
      invoiceCompany: personData.invoiceCompany,
      invoiceStreet: personData.invoiceStreet,
      invoiceStreetNumber: personData.invoiceStreetNumber,
      invoicePostcode: personData.invoicePostcode,
      invoiceLocation: personData.invoiceLocation,
      email: personData.email,
      mobileNumber: personData.mobileNumber
    };
    const numValidInvoiceFields =
      !!profile.invoiceCompany +
      !!profile.invoiceStreet +
      !!profile.invoiceStreetNumber +
      !!profile.invoicePostcode +
      !!profile.invoiceLocation;
    if (numValidInvoiceFields > 0 && numValidInvoiceFields < 5) {
      this.props.addNotifications([
        new Notification(locale.invoiceAddressErrorNotification, 'error', 10000)
      ]);
      return;
    }
    updateProfle(profile).then((response) => {
      if (response.updated) {
        this.props.addNotifications([
          new Notification(
            locale.editProfileCompletedNotification,
            'success',
            6000
          )
        ]);
        this.props.addUser({user: this.getPersonUpdateData(profile)});
      } else {
        this.props.addNotifications([
          new Notification(locale.editProfileErrorNotification, 'error', 6000)
        ]);
      }
    });
  };

  /**
   * Handles the submit of the user profile edit button and updates the user detail information.
   *
   * @param {Object} personData - Person data from submit action.
   */
  handleUserProfileUpdateSubmit = (personData: Object) => {
    if (this.state.userId && personData) {
      addChangeApplication(personData).then((response) => {
        if (response.created) {
          this.props.addNotifications([
            new Notification(
              locale.editUserProfileCompletedNotification,
              'success',
              6000
            )
          ]);
        } else {
          this.props.addNotifications([
            new Notification(
              locale.editUserProfileErrorNotification,
              'error',
              6000
            )
          ]);
        }
      });
    }
  };

  /**
   * Renders UserProfile component
   *
   * @return {string} - user profile component to be rendered
   */
  render() {
    return (
      <Fragment>
        {this.state.userData && (
          <div>
            <NotaryForm
              exportMail
              handleSubmit={this.handleUserProfileUpdateSubmit}
              handleProfileSubmit={this.handleProfileSubmit}
              headline={
                this.state.userData.firstName + ' ' + this.state.userData.name
              }
              data={this.state.userData}
              showProfileSaveButton={true}
              showProfileSubmitButton={true}
              showProfileFields={true}
              saveButtonLabel={locale.userProfileUpdateButton}
              showUserActionRow={true}
              hidePatentDate={true}
            />
            <NotaryContracts
              personId={this.props.user.id}
              signatureDeclaration={
                this.state.userData.signatureDeclarationDocument
              }
              termination={false}
              registration={false}
              editMode={true}
              profileMode={true}
            />
            <NotaryApiManagement />
          </div>
        )}
      </Fragment>
    );
  }
}

ConnectedUserProfile.propTypes = {
  addNotifications: PropTypes.func.isRequired,
  addUser: PropTypes.func.isRequired,
  user: PropTypes.object
};

const UserProfile = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedUserProfile);
export default UserProfile;
